export type ToastSeverity = 'success' | 'info' | 'warning' | 'error';

export const TOAST_EVENT = 'app:toast';

export interface ToastEventDetail {
  message: string;
  severity?: ToastSeverity;
  durationMs?: number;
}

export function emitToast(detail: ToastEventDetail) {
  try {
    window.dispatchEvent(new CustomEvent<ToastEventDetail>(TOAST_EVENT, { detail }));
  } catch {
    // no-op in non-browser
  }
}
